import { Link } from "react-router-dom";
import { byId } from "@/lib/chains";
import { ExplorerLink } from "@/components/ExplorerLink";
import type { Collection } from "./types";

/** Header used by every dashboard row — name + kind + chain + addr + public link. */
export function CollectionHeader({ c }: { c: Collection }) {
  const chain = byId(c.chainId);
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-baseline gap-2">
        <span className="font-semibold">{c.name}</span>
        <span className="text-xs uppercase tracking-wide text-muted-foreground">{c.kind}</span>
      </div>
      <div className="flex flex-wrap items-center gap-1 text-xs text-muted-foreground">
        <span>{c.symbol}</span>
        <span>·</span>
        <span>{chain?.name ?? `chain ${c.chainId}`}</span>
        <span>·</span>
        <ExplorerLink chain={chain} kind="address" value={c.contractAddress} />
        <span>·</span>
        <Link
          to={`/${chain?.shortName ?? `c${c.chainId}`}/${c.contractAddress}`}
          className="underline-offset-2 hover:underline"
        >
          public page
        </Link>
      </div>
    </div>
  );
}
